// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","topDecoration":"OverlayFooters_topDecoration__q2Bzk","companyAvatar":"OverlayFooters_companyAvatar__ECAgu"};